import React, { useState } from 'react'
import Plane from './Plane'
import Walls from './Walls'
import img from '../Assets/40.png'

const Space1 = ({ wallData }) => {

    return (
        <>
            <Plane  sceneImg={img} sceneSize={[329.52, 255.616]} />
            <Walls  wallData={wallData} />
        </>
    )
}

export default Space1
